import React, { useEffect, useMemo, useState } from 'react';
import { Spin } from 'antd';

import * as styles from './criticality-position-status-history.module.scss';
import { BasicTable } from '../../assets/common';
import positionProfileApi from '../../services/positionProfileApi';

function CriticalityPositionStatusHistory({ positionCode }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCriticalityPositionStatusHistory = async () => {
    setLoading(true);
    try {
      const res = await positionProfileApi.getCriticalPostionStatusHistory(positionCode);
      if (res.status === 200) {
        setData(res.data.result);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCriticalityPositionStatusHistory();
  }, []);

  useEffect(() => {
    console.log(data);
  }, [data]);

  const COLUMNS = useMemo(
    () => [
      {
        title: 'No',
        width: '10%',
        render: (_, __, index) => <div className={styles.text}>{index + 1}</div>,
      },
      {
        title: 'Position Code',
        width: '15%',
        dataIndex: 'position_code',
        render: (text) => <div className={styles.text}>{text}</div>,
      },
      {
        title: 'Position Name',
        width: '30%',
        dataIndex: 'position_name',
        render: (text) => <div className={styles.text}>{text}</div>,
      },
      {
        title: 'Position Category',
        width: '15%',
        dataIndex: 'position_label',
        render: (text) => <div className={styles.text}>{text}</div>,
      },
      {
        title: 'Start Date',
        width: '15%',
        dataIndex: 'from_date',
        render: (text) => <div className={styles.text}>{text}</div>,
      },
      {
        title: 'End Date',
        width: '15%',
        dataIndex: 'to_date',
        render: (text) => <div className={styles.text}>{text}</div>,
      },
    ],
    []
  );

  return (
    <Spin spinning={loading}>
      <div className={styles.wrapper}>
        <div className={styles.title}>Critical Position Status History</div>
        <div className={styles.tableContainer}>
          <BasicTable
            rowKey="id"
            styles={{
              headerColor: '#8896A7',
              headerWeight: 700,
              borderRadius: 6,
            }}
            dataSource={data}
            columns={COLUMNS}
            pagination={false}
          />
        </div>
      </div>
    </Spin>
  );
}

export default CriticalityPositionStatusHistory;
